import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { advertiseGrab } from "../actions/advertiseGrab";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";
const HorizontalAdd = ({ setUniversalAd }) => {
  const [advertisement, setAdvertisement] = useState(null);
  useEffect(() => {
    advertiseGrab("horizontal", setAdvertisement);
  }, []);

  // Dimensions for horizontal ad (standard IAB leaderboard: 728x90px desktop, 320x50px mobile)
  const placeholderImage =
    "https://placehold.co/728x90?text=Ad+728x90&textColor=ff0000";

  const adUrl = advertisement?.advertisement_url
    ? cloudinaryUrl(advertisement.advertisement_url)
    : placeholderImage;

  return (
    <div className="bg-black text-white z-50 w-full flex justify-center relative">
      <img
        className="h-[100px] tablet:h-[200px] w-full object-contain"
        src={adUrl}
        alt="horizontal ad placement"
      />
      <AiOutlineClose
        className="absolute z-60 top-0 right-0 bg-black hover:scale-105 hover:bg-slate-300 hover:cursor-pointer hover:text-black transition-all"
        size={30}
        onClick={() => setUniversalAd(false)}
      />
    </div>
  );
};

export default HorizontalAdd;
